import React from "react";
import { HomeContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { userService } from "apiServices";
import {
  BannerWidget,
  MenuPanelWidget,
  ActivityNewsWidget,
  // PrivilegeWidget,
  ShortcutWidget,
} from "widgets";
import { Displays } from "components";

class HomeContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let resArr = await Promise.all([
      userService.GET_BANNER_LIST(),
      userService.GET_SHORTCUT_LIST(),
    ]);
    if (resArr) {
      this.setState({
        dataBanner: resArr[0].data.docs,
        dataShortcut: resArr[1].data.docs,
        isLoading: false,
      });
    }
  };

  handleClickMenu = (e) => {
    this.props.router.navigate(e.path);
  };

  render() {
    const { isLoading, dataBanner, dataShortcut } = this.state;
    return (
      <HomeContainerStyled>
        <div className="body_container">
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              <div className="banner_layout">
                <BannerWidget data={dataBanner} />
              </div>
              <div className="shortcut_layout">
                <ShortcutWidget data={dataShortcut} />
              </div>
              <div className="menu_panel_layout">
                <MenuPanelWidget />
              </div>
              <div className="activity_news_layout">
                <ActivityNewsWidget />
              </div>
              {/* <div className="privilege_layout">
                <PrivilegeWidget />
              </div> */}
            </>
          )}
        </div>
      </HomeContainerStyled>
    );
  }
}

export default withRouter(HomeContainer);
